import React, { SVGProps } from 'react';

import styled from 'styled-components';
import { theme } from '../../theme';
import { BaseBodyTextStyles } from '../typography';

export const circleRadius = 36;

export const circleStrokeWidth = 8;

const circumference = circleRadius * 2 * Math.PI;

export const StyledProgressCircleOuter = styled.svg`
  width: ${circleRadius * 2}px;
  height: ${circleRadius * 2}px;
  overflow: visible;
`;

type StyledProgressCircleProps = SVGProps<SVGCircleElement> & {
  percent: number;
};

export const StyledCircle = styled.circle<StyledProgressCircleProps>`
  fill: transparent;
  stroke-dasharray: ${circumference} ${circumference};
  stroke-dashoffset: ${({ percent }) =>
    circumference - percent * circumference};
  transition: stroke-dashoffset 250ms ease-in;
  /* set the circle to start at 0° */
  transform: rotate(-90deg);
  /* center the circle inside parent SVG */
  transform-origin: 50% 50%;
`;

export const StyledProgressCircleText = styled.text`
  ${BaseBodyTextStyles};
  font-weight: bold;
`;

export const StyledBackgroundCircle = styled.circle``;

export type AnimatedProgressCircleProps = {
  currentStep: number;
  stepCount: number;
  progressText: string;
};

export const AnimatedProgressCircle: React.FC<AnimatedProgressCircleProps> = ({
  currentStep,
  stepCount,
  progressText,
}) => (
  <StyledProgressCircleOuter>
    <StyledBackgroundCircle
      r={circleRadius}
      cx={circleRadius}
      cy={circleRadius}
      fill="transparent"
      stroke={theme.colors.neutrals.solidGrays[6]}
      strokeWidth={circleStrokeWidth}
    ></StyledBackgroundCircle>
    <StyledCircle
      r={circleRadius}
      cx={circleRadius}
      cy={circleRadius}
      stroke={theme.colors.system.systemGreen}
      strokeWidth={circleStrokeWidth}
      percent={currentStep / stepCount}
    ></StyledCircle>
    <StyledProgressCircleText
      size="sm"
      x={circleRadius}
      y={circleRadius + 4}
      textAnchor="middle"
    >
      {progressText}
    </StyledProgressCircleText>
  </StyledProgressCircleOuter>
);
